/* SchemaForm helper value observer */
import React, { useEffect } from "react";
import { useFormikContext } from 'formik';


const ValuesObserver = ({ onChange }) => {
  const { values } = useFormikContext();
  useEffect(() => {
    if (onChange) onChange(values)
  }, [values]);
  return <div></div>;
};

export default ValuesObserver;